<template>
  <b-form
    hide-footer
    @submit.prevent="submitForm"
  >
    <div class="form-sectiontest">
      <div class="form-container">
        <div class="form-section">
          <h5 class="section-title">
            {{ $t('fixinfo') }}
          </h5>
          <div class="form-row">
            <b-form-group :label="$t('typefix')">
              <b-form-select
                v-model="form.categoryId"
                :options="categoriesOptions"
                required
                class="input-box"
                @change="fetchSubcategories"
              />
            </b-form-group>

            <b-form-group :label="$t('subcatefix')">
              <b-form-select
                v-model="form.subcategoryId"
                :options="subcategoriesOptions"
                :disabled="isLoadingfix || !form.categoryId"
                required
                class="input-box"
              />
              <b-spinner
                v-if="isLoadingfix"
                variant="border"
                small
              />
            </b-form-group>

            <b-form-group :label="$t('locationname')">
              <b-form-select
                v-model="form.locationId"
                :options="locationsOptions"
                class="input-box"
                required
              />
            </b-form-group>

            <b-form-group :label="$t('phone')">
              <b-form-input
                v-model="form.phone"
                maxlength="20"
                class="input-box"
                :placeholder="$t('phoneinput')"
              />
            </b-form-group>

          </div>
        </div>
      </div>

      <div class="form-container">
        <div class="form-section">
          <h5 class="section-title">
            {{ $t('fixinfodetails') }}
          </h5>
          <div class="form-row">
            <b-form-group :label="$t('problemdetails')">
              <b-form-textarea
                v-model="form.fixDetails.detail"
                :placeholder="$t('problemdetailsinput')"
                rows="3"
                class="input-text"
                required
                maxlength="150"
                @input="checkLength"
              />
              <small class="form-text text-muted">{{ form.fixDetails.detail.length }}/150 {{ $t('text') }}</small>
              <b-alert
                v-if="lengthExceeded"
                variant="danger"
                show
              >
                {{ $t('text150') }}
              </b-alert>
            </b-form-group>
          </div>
        </div>

        <div class="form-section">
          <h5 class="section-title">
            {{ $t('imageinfo') }}
          </h5>
          <b-form-group :label="$t('addimage')">
            <b-form-file
              multiple
              :placeholder="$t('selectimage')"
              class="input-image"
              @change="handleFileChange"
            />
          </b-form-group>
        </div>
      </div>

      <div class="form-buttons">
        <b-button
          variant="secondary"
          @click="$emit('close')"
        >
          {{ $t('cancel') }}
        </b-button>
        <b-button
          type="submit"
          variant="primary"
        >
          {{ $t('submit') }}
        </b-button>
      </div>
    </div>
    <b-modal
      id="errorModal"
      :title="$t('notification')"
      :ok-title="$t('confirm')"
      hide-footer
      @ok="handleModalOk"
    >
      <h5>{{ $t('noticdetailsfix') }}</h5>
    </b-modal>

    <div
      v-if="isLoading"
      class="overlay"
    >
      <div class="loading-container">
        <b-spinner
          label="Loading..."
          class="spinner"
        />
        <p class="loading-text">
          {{ $t('loading') }}
        </p>
      </div>
    </div>
  </b-form>
</template>
<script>

import apiAdmin from '@/services/admin'
import apiMst from '@/services/masterDate'
import apiSetting from '@/services/Setting'
import { getRolesFromToken } from '@/services/JwtDecoder'
import apiAuth from '@/services/auth'
import emailservice from '@/services/emailservice'

export default {
  props: {
    fix: { type: Object, default: () => ({}) },
    categories: { type: Array, default: () => [] },
    devicecategories: { type: Array, default: () => [] },
    subcategories: { type: Array, default: () => [] },
    devicesubcategories: { type: Array, default: () => [] },
    devices: { type: Array, default: () => [] },
    locations: Array,

  },
  data() {
    return {
      form: {
        order: '',
        timefix: null,
        categoryId: null,
        subcategoryId: null,
        devicecategoryId: null,
        devicesubcategoryId: null,
        userId: this.$store.getters.userId,
        deviceId: null,
        operator: '',
        status: null,
        fixId: this.fix?.id || null,
        fixDetails: { detail: '' },
        locationId: null,
        phone: '',
      },
      subcategoriesOptions: [],
      categoriesOptions: this.categories.map(c => ({ value: c.id, text: c.nameCate })),
      devicecategoriesOptions: this.devicecategories.map(d => ({ value: d.id, text: d.name })),
      devicesubcategoriesOptions: [],
      devicesOptions: [],
      selectedFiles: [],
      lengthExceeded: false,
      isLoading: false,
      isLoadingfix: false,
      isLoadingDevice: false,
      isLoadingDeviceCate: false,
      locationsOptions: [],
      fixRequest: null,
    }
  },
  computed: {
    userId() {
      return this.$store.getters.userId
    },
  },
  watch: {
    fix: {
      immediate: true,
      handler(newFix) {
        if (newFix) {
          this.initializeForm(newFix)
        }
      },
      userId(newUserId) {
        this.form.userId = newUserId
      },
    },
    'form.devicecategoryId': function (newDeviceCategoryId) {
      if (newDeviceCategoryId) {
        this.fetchDeviceSubcategories()
      } else {
        this.resetDeviceFields()
      }
    },
    'form.devicesubcategoryId': function (newDeviceSubcategoryId) {
      if (newDeviceSubcategoryId) {
        this.fetchDevices()
      } else {
        this.devicesOptions = []
      }
    },
  },
  created() {
    this.accessToken = localStorage.getItem('accessToken')
    this.roles = getRolesFromToken(this.accessToken)
    this.locationsOptions = this.locations.map(l => ({ value: l.id, text: l.locationName }))
  },
  methods: {
    initializeForm(newFix) {
      console.log('Initializing form with newFix:', newFix)
      this.form.userId = this.$store.getters.userId
      this.form = {
        order: newFix.order || '',
        categoryId: newFix.category?.id || null,
        subcategoryId: newFix.subcategory?.id || null,
        devicecategoryId: newFix.device?.category?.id || null,
        devicesubcategoryId: newFix.device?.subcategory?.id || null,
        deviceId: newFix.device?.id || null,
        operator: newFix.operator || '',
        status: newFix.status || '',
        locationId: newFix.location?.id || null,
        timefix: newFix.timefix ? this.convertToThaiTime(newFix.timefix) : '',
        fixDetails: Array.isArray(newFix.fixDetails) && newFix.fixDetails.length > 0
          ? { detail: newFix.fixDetails[0]?.detail || '' }
          : { detail: '' },
        phone: newFix.phone || '',
        fixId: newFix.id || null,
      }

      this.fetchSubcategoriesIfNeeded()
    },
    handleModalOk() {
      this.$bvModal.hide('errorModal')
    },
    convertToThaiTime(utcDate) {
      const date = new Date(utcDate)
      date.setHours(date.getHours() + 7) // เพิ่ม 7 ชั่วโมง
      return date.toISOString().slice(0, 16) // แปลงกลับเป็นรูปแบบที่ต้องการ
    },
    convertToUtcTime(localDate) {
      if (!localDate) return null
      const date = new Date(localDate)
      if (isNaN(date.getTime())) {
        console.error('Invalid date value:', localDate)
        return null
      }
      return date.toISOString()
    },
    fetchSubcategoriesIfNeeded() {
      if (this.form.categoryId) this.fetchSubcategories()
      if (this.form.subcategoryId) this.fetchDevices()
      if (this.form.devicecategoryId) this.fetchDeviceSubcategories()
      if (this.form.devicesubcategoryId) this.fetchDevices()
    },
    resetDeviceFields() {
      this.devicesubcategoriesOptions = []
      this.devicesOptions = []
    },
    handleFileChange(event) {
      this.selectedFiles = Array.from(event.target.files)
    },
    async uploadFiles(url, files) {
      if (files.length === 0) return
      const formData = new FormData()
      files.forEach(file => formData.append('files', file))
      formData.append('fixId', this.form.order || '')

      try {
        const response = await apiAdmin.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        return response.data
      } catch (error) {
        console.error('Error uploading files:', error)
        alert('เกิดข้อผิดพลาดในการอัปโหลดไฟล์')
        throw error
      }
    },

    async submitForm() {
      this.isLoading = true
      try {
        console.log('Form data before submit:', this.form)
        if (!this.form.categoryId || !this.form.subcategoryId || !this.form.locationId) {
          alert('กรุณากรอกข้อมูลให้ครบถ้วน')
          return
        }

        if (!this.form.fixDetails.detail || !this.form.fixDetails.detail.trim()) {
          this.$bvModal.show('errorModal')
          return
        }

        const emailList = ['itga@fukuyama-gl.com']

        if (emailList.length === 0) {
          throw new Error('ไม่พบอีเมลที่เกี่ยวข้องกับบทบาทปัจจุบัน')
        }

        this.form.userId = this.userId

        const fixResponse = await this.saveFix()
        this.form.fixId = fixResponse.data.id
        this.form.order = fixResponse.data.order

        if (!this.form.fixDetails.detail || !this.form.fixDetails.detail.trim()) {
          this.$bvModal.show('errorModal')
          return
        }

        if (!this.form.fixId) {
          throw new Error('ไม่สามารถบันทึก fix ได้')
        }

        await this.saveFixDetail()
        await this.uploadFiles('/uploads', this.selectedFiles)

        console.log('Status ที่จะส่ง:', this.form.statusId)
        const statusId = Number(this.form.statusId)
        this.$store.commit('setStatusId', statusId)

        await this.sendEmailNotification(emailList, this.form)
        await this.$emit('close')

        this.$store.commit('setStatusId', null)
      } catch (error) {
        console.error('Error saving data:', error)
        alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล')
      } finally {
        this.isLoading = false
      }
    },

    async saveFix() {
      let statusId = this.form.status
      if (this.roles.includes('APPROVER')) {
        statusId = 2
      } else {
        statusId = 1
      }

      this.form.statusId = statusId

      const payload = {
        order: this.form.order,
        status: { id: statusId },
        timefix: this.form.timefix ? this.convertToUtcTime(this.form.timefix) : null,
        timefixget: this.form.timefixget || null,
        timefixtk: this.form.timefixtk || null,
        timefixdone: this.form.timefixdone || null,
        operator: this.form.operator || null,
        user: { id: this.form.userId },
        category: { id: this.form.categoryId },
        subcategory: { id: this.form.subcategoryId },
        location: { id: this.form.locationId },
        phone: this.form.phone || null,
      }

      const endpoint = this.form.fixId ? `/fixUpdate/${this.form.fixId}` : '/fixAdd'
      try {
        const response = await apiAdmin[!this.form.fixId ? 'post' : 'put'](endpoint, payload)
        console.log('Response จาก API:', response)
        return response
      } catch (error) {
        console.error('Error saving fix:', error.response ? error.response.data : error.message)
        throw new Error(`เกิดข้อผิดพลาดในการบันทึก fix: ${error.message}`)
      }
    },

    async saveFixDetail() {
      if (!this.form.fixId) {
        console.error('fixId is null when saving fix detail')
        throw new Error('fixId ไม่มีค่า')
      }

      const detailPayload = {
        detail: this.form.fixDetails.detail,
        order: this.form.order,
        fixDet: { id: this.form.fixId },
      }

      console.log('Saving Fix Detail:', detailPayload)

      const endpoint = this.form.fixDetailId ? `/detailsUpdate/${this.form.fixDetailId}` : '/detailsAdd'

      try {
        await apiAdmin[!this.form.fixDetailId ? 'post' : 'put'](endpoint, detailPayload)
      } catch (error) {
        console.error('Error saving fix detail:', error.response ? error.response.data : error.message)
        throw error
      }
    },

    async fetchSubcategories() {
      if (!this.form.categoryId) return

      this.isLoadingfix = true
      try {
        const response = await apiSetting.get(`/subcate/${this.form.categoryId}`)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.subcategoriesOptions = response.data.map(sc => ({ value: sc.id, text: sc.name }))
        } else {
          this.subcategoriesOptions = []
          console.warn('ไม่พบหมวดหมู่ย่อย')
          this.$bvToast.toast(this.$t('notfoundsubcate'), {
            title: this.$t('warning'),
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Error fetching subcategories:', error)
        this.subcategoriesOptions = []
        this.$bvToast.toast(this.$t('getsubcatefailed'), {
          title: this.$t('error'),
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isLoadingfix = false
      }
    },

    async fetchDevices() {
      if (!this.form.devicesubcategoryId) {
        this.devicesOptions = []
        return
      }

      this.isLoadingDevice = true
      try {
        const response = await apiMst.get(`/deviceList/${this.form.devicesubcategoryId}`)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.devicesOptions = response.data.map(d => ({ value: d.id, text: d.deviceName }))
        } else {
          this.devicesOptions = []
          console.warn('ไม่พบข้อมูลอุปกรณ์ในหมวดหมู่ย่อยนี้')
          this.$bvToast.toast(this.$t('notfoundsubcateIndevice'), {
            title: this.$t('warning'),
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Error fetching devices:', error)
        this.devicesOptions = []
        this.$bvToast.toast(this.$t('getdevicefailed'), {
          title: this.$t('error'),
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isLoadingDevice = false
      }
    },

    async fetchDeviceSubcategories() {
      if (!this.form.devicecategoryId) return

      this.isLoadingDeviceCate = true
      try {
        const response = await apiMst.get(`/subdevice/${this.form.devicecategoryId}`)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.devicesubcategoriesOptions = response.data.map(dsc => ({ value: dsc.id, text: dsc.name }))
        } else {
          this.devicesubcategoriesOptions = []
          console.warn('ไม่พบหมวดหมู่ย่อยของอุปกรณ์')
          this.$bvToast.toast(this.$t('notfoundsubcatedevice'), {
            title: this.$t('warning'),
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Error fetching device subcategories:', error)
        this.devicesubcategoriesOptions = []
        this.$bvToast.toast(this.$t('getsubcatedevicefailed'), {
          title: this.$t('error'),
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isLoadingDeviceCate = false
      }
    },
    checkLength() {
      if (this.form.fixDetails.detail.length >= 150) {
        this.lengthExceeded = true
        this.form.fixDetails.detail = this.form.fixDetails.detail.slice(0, 150)
      } else {
        this.lengthExceeded = false
      }
    },

    async fetchApproverEmails(userId) {
      try {
        const response = await apiAuth.post('/email/search', { userId })
        if (response.status === 200) {
          const match = response.data.match(/\[([^\]]+)\]/)
          if (match && match[1]) {
            return match[1].split(',').map(email => email.trim())
          }
          throw new Error('No emails found in API response')
        }
        throw new Error('Failed to fetch approver emails')
      } catch (error) {
        console.error('Error fetching approver emails:', error)
        throw error
      }
    },

    async fetchWorkerEmails() {
      try {
        const response = await apiAuth.post('/email/searchrolemail', { roleId: 3 })

        if (response.status === 200) {
          const emails = response.data
          if (Array.isArray(emails) && emails.length > 0) {
            return emails.map(email => email.trim())
          }
          throw new Error('No emails found in API response')
        }
        throw new Error('Failed to fetch worker emails')
      } catch (error) {
        console.error('Error fetching worker emails:', error)
        throw error
      }
    },

    async sendEmailNotification(emailData) {
      try {
        if (!emailData || emailData.length === 0) {
          throw new Error('Recipients list is empty')
        }

        const isTokenValid = emailservice.isTokenValid()
        if (!isTokenValid) {
          throw new Error('Please log in again to send emails')
        }
        const username = localStorage.getItem('username')
        const orderId = this.form.order ?? 'N/A'

        const emailTemplate = `
      <!DOCTYPE html>
      <html>
      <body>
        <p style="font-size: 18px;">เรียน <strong>ฝ่ายเทคโนโลยีสารสนเทศและกิจการทั่วไป</strong>,</p>
        <p>ขอความอนุเคราะห์เพื่อดำเนินการซ่อมต่อไป มีรายละเอียดดังนี้:</p>
        <ul>
          <li>หมายเลขแจ้งซ่อม: ${this.form.order ?? 'N/A'}</li>
          <li>ผู้แจ้งซ่อม: ${username ?? 'N/A'}</li>
          <li>แจ้งซ่อมเวลา: ${this.formatDate(new Date(), 'short')}</li>
          <li>หมวดหมู่ปัญหา: ${this.getCategoryNameById(this.form.categoryId)}</li>
          <li>หมวดหมู่ปัญหาย่อย: ${this.getSubcategoryNameById(this.form.subcategoryId)}</li>
          <li>สถานที่: ${this.getlocationNameById(this.form.locationId)}</li>
          <li>รายละเอียด: ${this.form.fixDetails.detail}</li>
        </ul>
        <p>ท่านสามารถคลิกลิงก์นี้เพื่อดูรายละเอียดเพิ่มเติม:<a href="https://mns.gelogs.co.th/admin/search/${orderId}">ดูรายละเอียดการแจ้งซ่อม</a></p>
        <p>ขอแสดงความนับถือ</p>
      </body>
      </html>
    `

        await emailservice.sendEmailWithTemplate(emailData, emailTemplate, {
          subject: `รายละเอียดการแจ้งซ่อม (${this.form.order ?? 'N/A'})`,
        })
      } catch (error) {
        console.error('Error sending email:', error)
        throw error
      }
    },

    getCategoryNameById(id) {
      const category = this.categories.find(c => c.id === id)
      return category ? category.nameCate : 'N/A'
    },

    getSubcategoryNameById(id) {
      const subcategory = this.subcategoriesOptions.find(sc => sc.value === id)
      return subcategory ? subcategory.text : 'N/A'
    },

    getlocationNameById(id) {
      const location = this.locationsOptions.find(d => d.value === id)
      return location ? location.text : 'N/A'
    },
	
	formatDate(date, formatType = 'short') {
	const options = { 
		year: 'numeric', 
		month: formatType === 'short' ? 'short' : 'long',
		day: 'numeric' 
	}
	const formatter = new Intl.DateTimeFormat('en-GB', options)
    return formatter.format(date)
    },
  }
}
</script>
<style scoped>
.form-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  flex: 1;
}

.form-sectiontest {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  gap: 30px;
}

.form-row .b-form-group {
  flex: 1;
}

.section-title {
  background-color: #4a6a8c;
  color: white;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
}

.form-buttons {
  margin-top: 15px;
  margin-bottom: 20px;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
}

.input-box {
  width: 18vw;
  height: 40px;
}

.custom-dropdown .form-select-dropdown {
  max-height: 150px;
  overflow-y: auto;
}

.input-text{
  margin-left: 15px;
  width: 42vw;
  height: 150px;
  resize: none;
}

.input-image{
  width: 400px;
  height: 50px;
}

.form-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap
}

.form-section {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .form-container {
    flex-direction: column;
  }
  .input-image{
  width: 100%;
  height: 50px;
  }
  .input-box {
  width: 100%;
  height: 40px;
  }
}

.loading-text {
  margin-top: 10px;
  font-size: 16px;
}
.b-spinner {
  color: white;
}
.loading-container {
  text-align: center;
  color: #fff;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
